import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=5e72551f&scoped=true&"
import script from "./Brokers.vue?vue&type=script&lang=js&"
export * from "./Brokers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72551f",
  null
  
)

export default component.exports